'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencyNotificationPreference } from '../../Entities/Agency/AgencyNotificationPreference';
import { AgencyNotificationPreferenceCollection } from '../../Collections/Agency/AgencyNotificationPreferenceCollection';

export class AgencyNotificationPreferenceRepository extends CoreRepository {
  public getAgencyNotificationPreferences(agencyId: number, options: object = {}) {
    return this.webAPI.getAgencyNotificationPreferences(agencyId, options).then((response) => {
      const collection = new AgencyNotificationPreferenceCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new AgencyNotificationPreference();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addAgencyNotificationPreference(agencyId: number, payload: any[]) {
    return this.webAPI.addAgencyNotificationPreference(agencyId, payload).then((response) => {
      const item = new AgencyNotificationPreference();
      item.hydrate(response);

      return item;
    });
  }

  public updateAgencyNotificationPreference(
    agencyId: number,
    notificationPreferenceId: number,
    payload: any[]
  ) {
    return this.webAPI
      .updateAgencyNotificationPreference(agencyId, notificationPreferenceId, payload)
      .then((response) => {
        return response;
      });
  }

  public deleteAgencyNotificationPreference(agencyId: number, notificationPreferenceId: number) {
    return this.webAPI
      .deleteAgencyNotificationPreference(agencyId, notificationPreferenceId)
      .then((response) => {
        return response;
      });
  }
}
